// parses stringified JSON for company address & formats for display

export default function parseClientCompanyAddress(address) {
  let clientAddress = address && JSON.parse(address)

  let streetAddress =
    clientAddress &&
    `${clientAddress.street_number || ""} ${
      clientAddress.route ? clientAddress.route : ""
    }`
  let stateAddress =
    clientAddress &&
    `${clientAddress.city + "," || ""} ${clientAddress.state + "," ||
      ""} ${clientAddress.zip || ""}`
  return [streetAddress, stateAddress]
}
